/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, KONOIKE){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	
	const officerModal = () => {
		let scrollTopNow;
		if($('.js-modalBtn').length) {
			$('.js-modalBtn').on('click', (e) => {
				let $this = $(e.currentTarget);
				let thisModalHtml = $this.next('.js-modalItem').prop('outerHTML');
				fixedOnContainer();

				$('.js-modal-base').append(thisModalHtml);
				$('.js-modal').addClass(a);
				$('.js-modal-overlay').on('click', () => {
					$('.js-modal').removeClass(a);
					$('.js-modal').find('.js-modalItem').remove();
					$('.js-modal-overlay').off();
					fixedOffContainer();
				});
				$('.js-modal-close').on('click', () => {
					$('.js-modal').removeClass(a);
					$('.js-modal-close').off();
					$('.js-modal').find('.js-modalItem').remove();
					fixedOffContainer();
				});
			});
		}

		const fixedOnContainer = () => {
			scrollTopNow = $(window).scrollTop();
			$('.container').css({
				position: 'fixed',
				width: '100%',
				top: -1 * scrollTopNow,
				left: 0
			});
			$('body').addClass(f);
		};
		const fixedOffContainer = () => {
			$('.container').css({
				position: 'static'
			});
			$('body').removeClass(f);
			$(window).scrollTop(scrollTopNow);
		};
	}

	// ===========================================================================
	officerModal();

})(window.jQuery, window.KONOIKE);
